<template>
  <b-container fluid>
   
  </b-container>
</template>

<script lang="ts">
import { Component, Vue, Watch, Prop, Provide } from "vue-property-decorator";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import DescriptionDataSet from "./DescriptionDataSet.vue";
import * as JQuery from "jquery";

@Component({
  components: {
    FontAwesomeIcon,
    DescriptionDataSet,
    JQuery
  },
})
export default class DesignerDescription extends Vue {
   @Prop({default: () => "secondary"})
    public Variant!: string;

  @Prop()
  Parameter!: string;

  public save(){
    
  }
}
</script>

<style scoped>

</style>